import {Stack, Text} from "@mantine/core";
import {ResponsiveBar} from "@nivo/bar";
import './styles.scss';
import NumberUtils from "../../../utils/number.utils";

interface Props {
    title: string,
    data?: any[],
    keys: string[],
    indexBy: string,
    groupMode?: string,
    colors?: any,
    legends?: any[],

    axisLeftName: string,
    axisBottomName: string,
    axisBottomRotation?: number,

    formatValue?: (value: any) => string | number,
    formatXAxis?: (value: any) => string | number,
    tooltip?: (props: any) => any,
}

function WidgetNivoBar(props: Props) {

    const {
        title,
        data,
        indexBy,
        keys,
        axisBottomName,
        axisLeftName,
        formatValue,
        tooltip,
        formatXAxis,
        axisBottomRotation,
        groupMode,
        colors,
        legends
    } = props;

    let curProps: any = {}
    if (formatValue) {
        curProps.label = formatValue;
        curProps.valueFormat = formatValue;
    }
    if (tooltip) {
        curProps.tooltip = tooltip;
    }

    function renderGraph() {
        if (data) {
            return (
                <ResponsiveBar
                    data={data}
                    keys={keys}
                    indexBy={indexBy}
                    margin={{top: 0, right: 20, bottom: 60, left: 60}}
                    padding={0.3}
                    groupMode={groupMode ? groupMode : "stacked"}
                    valueScale={{type: 'linear'}}
                    indexScale={{type: 'band', round: true}}
                    colors={colors ? colors : "#6CADD9"}
                    borderRadius={0}
                    enableLabel={false}
                    legends={legends}
                    borderColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                1.6
                            ]
                        ]
                    }}
                    layers={['grid', 'axes', 'bars', 'legends']}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        format: formatXAxis,
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: axisBottomRotation || 0,
                        legend: axisBottomName,
                        legendPosition: 'middle',
                        legendOffset: 55
                    }}
                    axisLeft={{
                        format: v => NumberUtils.toShortened(v, 0),
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: axisLeftName,
                        legendPosition: 'middle',
                        legendOffset: -40
                    }}
                    role="application"
                    tooltip={tooltip}
                    ariaLabel="Nivo bar chart demo"
                    barAriaLabel={function (e) {
                        return e.id + ": " + e.formattedValue + " in country: " + e.indexValue
                    }}
                    {...curProps}
                />
            )
        } else {
            return (
                <Stack align="center">
                    <Text>No Data Found</Text>
                </Stack>
            )
        }
    }

    return (
        <div className="widget-nivo-base">
            <div className='header'>
                <Text>
                    {title}
                </Text>
            </div>
            <div className='widget-chart-container'>
                {renderGraph()}
            </div>
        </div>
    )
}

export default WidgetNivoBar;